module.exports = __webpack_public_path__ + "static/media/cosmosbanner.e12e5951.png";